import { useEffect, useState } from "react";
import { useOutletContext, useParams } from "react-router";
import Loader from "../../loader/loader";
import { FUNNEL_PERFORMANCE_DURATION_FILTER } from "../../strings";
import { PerformanceCard } from "../../customers/performance-card";
import { getFunnelsReport } from "../../../services/api-declaration";

const FunnelPerformance = () => {
  const { id } = useParams();
  const { funnel } = useOutletContext();
  const [isLoading, setIsLoading] = useState(true);
  const [report, setReport] = useState(null);

  useEffect(() => {
    // Fetch funnel performance report only once, after that PerformanceCard component will handle the data fetching itself by other api, based on the filters applied
    const fetchFunnelsPerformance = async () => {
      try {
        const response = await getFunnelsReport({
          _id: id,
          dateRange: FUNNEL_PERFORMANCE_DURATION_FILTER.FORTNIGHT
        });
        setReport(response.data.data);
      } catch (error) {
        console.log("Error in getting funnels performance: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchFunnelsPerformance();
  }, [id]);

  return (
    <div className="my-4">
      {isLoading ? (
        <Loader />
      ) : (
        <PerformanceCard
          report={report}
          customerId={funnel.customer._id}
          funnelId={id}
          fromFunnelPerformanceView
        />
      )}
    </div>
  );
};
export default FunnelPerformance;
